import { createAction } from '@reduxjs/toolkit'
import { ChainId } from '@traderjoe-xyz/joepegs-sdk'
import { WrapCurrencyModalProps } from 'components/WrapCurrencyModal'

export type PopupContent = {
  state: 'success' | 'error' | 'loading'
  chainId?: ChainId
  hash?: string
  summary?: string
}

export enum ApplicationModal {
  MINT_SUCCESS,
  WRAP_CURRENCY,
  FULL_SCREEN_ITEM,
  CANCEL_ALL_OFFERS_AND_LISTINGS,
  REPORT_COLLECTION
}

export const updateBlockNumber = createAction<{
  blockNumber: number
  chainId: number
}>('application/updateBlockNumber')

export const setOpenModal = createAction<ApplicationModal>(
  'application/setOpenModal'
)

export const closeModal = createAction<ApplicationModal>(
  'application/closeModal'
)

export const setWrapCurrencyModalArgs = createAction<
  WrapCurrencyModalProps | undefined
>('application/setWrapCurrencyModalArgs')
